// Visual note-duration category derived from the actual playback ms.
// Used to pick a notation glyph on the staff (eighth / quarter / half / whole).
//
// It's proportional, not absolute: `baseMs` is roughly one beat at the tempo
// the caller is playing, so the ambient studio (≈1s per letter) and the live
// projector (≈0.5s per letter) both get a mix of glyphs instead of every note
// collapsing into one shape.
export function getDurationCategory(stepMs, baseMs = 200) {
  if (stepMs == null) return "quarter";
  const r = stepMs / (baseMs || 200);
  if (r >= 4.5) return "whole";
  if (r >= 2.25) return "half";
  if (r >= 1) return "quarter";
  return "eighth";
}
